export default {
  INITIALIZE_BLOCK: '@WS/INITIALIZE_BLOCK',
  SET_BLOCKS: '@WS/SET_BLOCKS',
  SET_BLOCK_HTML: '@WS/SET_BLOCK_HTML',
  SET_BLOCK_VARIATION_HTML: '@WS/SET_BLOCK_VARIATION_HTML',
  SET_BLOCK_CONTAINER: '@WS/SET_BLOCK_CONTAINER',
  SET_CATEGORIES: '@WS/SET_CATEGORIES',
};
